<template>
  <div>
    <b-form-group
      label="Selecione a Região de Atuação"
      label-for="tags-with-dropdown"
    >
      <b-form-tags
        id="tags-with-dropdown"
        :value="regioes"
        @input="alteraRegiao"
        no-outer-focus
        class="mb-2"
      >
        <template v-slot="{ tags, disabled, addTag, removeTag }">
          <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
            <li v-for="(tag, t) in tags" :key="t" class="list-inline-item">
              <b-form-tag
                @remove="removeTag(tag)"
                :title="getUf(tag)"
                :disabled="disabled"
                variant="info"
                >{{ getUf(tag) }}</b-form-tag
              >
            </li>
          </ul>

          <b-dropdown
            size="sm"
            variant="outline-secondary"
            block
            menu-class="w-100"
          >
            <template #button-content>
              <b-icon icon="tag-fill"></b-icon> Selecione um estado
            </template>
            <b-dropdown-form @submit.stop.prevent="() => {}">
              <b-form-group
                label="Pesquisar Região"
                label-for="tag-search-input"
                label-cols-md="auto"
                class="mb-0"
                label-size="sm"
                :description="searchDesc"
                :disabled="disabled"
              >
                <b-form-input
                  v-model="search"
                  id="tag-search-input"
                  type="search"
                  size="sm"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
            </b-dropdown-form>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item-button
              v-for="option in availableOptions"
              :key="option.id"
              class="list-inline d-inline-block mb-2"
              @click="onOptionClick({ option, addTag, removeTag })"
            >
              {{ option.uf }}
            </b-dropdown-item-button>
            <b-dropdown-text v-if="availableOptions.length === 0">
              Nenhum resultado encontrado
            </b-dropdown-text>
          </b-dropdown>
        </template>
      </b-form-tags>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "v-tag",
  props: {
    regioes: {
      type: Array,
      default: () => [],
    },
  },
  model: {
    prop: "regioes",
    event: "input",
  },
  data() {
    return {
      options: [],
      search: "",
      value: [],
    };
  },
  created() {
    this.loadRegioes();
  },
  methods: {
    onOptionClick({ option, addTag, removeTag }) {
      if (option.uf === "TODOS") {
        this.availableOptions.forEach((el) => {
          if (el.uf !== "TODOS" && el.uf !== "REMOVER TODOS") {
            addTag(el.id.toString());
          }
        });
      } else if (option.uf === "REMOVER TODOS") {
        this.alteraRegiao([]);
        //this.regioes = [];
      } else {
        addTag(option.id.toString());
        this.alteraRegiao(option);
        this.search = "";
      }
    },
    loadRegioes() {
      var vm = this;
      $(".loading").show();
      axios("/estados")
        .then(function (response) {
          vm.options = response.data;
          $(".loading").hide();
        })
        .catch(function (error) {
          console.log(error);
          $(".loading").hide();
        });
    },
    alteraRegiao(tag) {
      this.$emit("alteraRegiao", tag);
    },
    getUf(id) {
      var obj = this.options.find((el) => el.id === parseInt(id));
      if (obj) {
        return obj.uf;
      } else {
        return "N/A";
      }
    },
  },
  computed: {
    criteria() {
      return this.search.trim().toLowerCase();
    },
    availableOptions() {
      const criteria = this.criteria;
      const options = this.options.filter(
        (opt) => this.regioes.indexOf(opt.id.toString()) === -1
      );
      if (criteria) {
        return options.filter(
          (opt) => opt.uf.toLowerCase().indexOf(criteria) > -1
        );
      }
      options.push({ uf: "TODOS" }, { uf: "REMOVER TODOS" });
      return options;
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return "Nenhum resultado encontrado";
      }
      return "";
    },
  },
};
</script>

<style scoped="">
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/util/Tag.vue